/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/require-snake-case-analytics */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-controllers */
/* eslint-disable ember/no-classic-classes */
import { reads } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
export default Controller.extend({
  intercomEventService: service(),
  appController: controller('apps.app'),
  app: reads('appController.model'),
  // eslint-disable-next-line @intercom/intercom/no-legacy-modal
  modalService: service(),
  usersOrLeads: reads('model.recordType'),

  openTaggingModal: action(function (component, model, options) {
    this.modalService.openModal(component, model, options);
  }),

  actions: {
    completeImport() {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'csv-import-initated',
        object: 'csv-import',
      });
      this.model.createUserCreateJob();
      this.transitionToRoute('apps.app.import.csv.finish', this.model);
    },
  },
});
